<template>
  <article class="activity-skeleton">
    <div class="activity-skeleton__left">
      <div class="activity-skeleton__photo">
        <div class="activity-skeleton__image"></div>
      </div>
      <div class="activity-skeleton__details">
        <div class="activity-skeleton__title"></div>
        <div class="activity-skeleton__badges">
          <div class="activity-skeleton__badge activity-skeleton__badge--short"></div>
          <div class="activity-skeleton__badge"></div>
        </div>
        <div class="activity-skeleton__location"></div>
        <div class="activity-skeleton__desc"></div>
        <div class="activity-skeleton__desc activity-skeleton__desc--short"></div>
      </div>
    </div>
    <div class="activity-skeleton__right">
      <div class="activity-skeleton__rating"></div>
      <div class="activity-skeleton__price-block">
        <div class="activity-skeleton__price"></div>
        <div class="activity-skeleton__price-sub"></div>
      </div>
    </div>
  </article>
</template>

<style scoped lang="scss">
$border-color: var(--grey-border);
$background-color: var(--white);
$image-background: var(--grey);
$placeholder-background: var(--grey-loader-additional, #e8e8e8);
$shimmer-duration: 1.6s;

@mixin shimmer($base-color) {
  background-color: $base-color;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0) 100%);
  background-size: 200% 100%;
  background-repeat: no-repeat;
  animation: shimmer $shimmer-duration ease-in-out infinite;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.activity-skeleton {
  display: flex;
  gap: 16px;
  border-radius: 10px;
  box-shadow: 0 0 0 2px $border-color;
  background: $background-color;
  height: 232px;

  @media (max-width: 767px) {
    height: auto;
    flex-direction: column;
  }
}

.activity-skeleton__left {
  display: flex;
  flex: 1;
}

.activity-skeleton__photo {
  width: 262px;
  min-width: 262px;
  border-radius: 10px 0 0 10px;
  overflow: hidden;

  @media (max-width: 1024px) and (min-width: 768px) {
    width: 194px;
    min-width: 194px;
  }

  @media (max-width: 767px) {
    width: 131px;
    min-width: 131px;
    border-radius: 10px 0 0 0;
  }
}

.activity-skeleton__image {
  @include shimmer($image-background);
  height: 100%;
  width: 100%;
  min-height: 232px;

  @media (max-width: 767px) {
    min-height: 252px;
  }
}

.activity-skeleton__details {
  flex: 1;
  padding: 20px 0 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 767px) {
    padding: 14px 16px;
  }
}

.activity-skeleton__title {
  @include shimmer($placeholder-background);
  height: 22px;
  width: 70%;
  border-radius: 25px;
}

.activity-skeleton__badges {
  display: flex;
  gap: 8px;
}

.activity-skeleton__badge {
  @include shimmer($placeholder-background);
  height: 24px;
  width: 72px;
  border-radius: 4px;

  &--short {
    width: 52px;
  }
}

.activity-skeleton__location {
  @include shimmer($placeholder-background);
  height: 18px;
  width: 50%;
  border-radius: 25px;
}

.activity-skeleton__desc {
  @include shimmer($placeholder-background);
  height: 16px;
  width: 90%;
  border-radius: 25px;

  &--short {
    width: 60%;
  }

  @media (max-width: 1024px) {
    display: none;
  }
}

.activity-skeleton__right {
  width: 168px;
  margin: 20px 20px 20px 0;
  border-left: 1px solid $border-color;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: row;
    border-left: none;
    border-top: 2px solid $border-color;
    margin: 0;
    padding: 18px 16px;
  }
}

.activity-skeleton__rating {
  @include shimmer($placeholder-background);
  height: 40px;
  width: 100px;
  border-radius: 6px;
}

.activity-skeleton__price-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.activity-skeleton__price {
  @include shimmer($placeholder-background);
  height: 22px;
  width: 80px;
  border-radius: 25px;
}

.activity-skeleton__price-sub {
  @include shimmer($placeholder-background);
  height: 14px;
  width: 100px;
  border-radius: 25px;
}
</style>
